module.exports = __webpack_public_path__ + "img/zwh.2f89d702.jpg";